import PropTypes from 'prop-types';
import SortByModal from './SortByModal';

const SortBy = ({ onSortByChange, sortItems, sortValue }) => {
  return sortItems?.length > 0 ? (
    <SortByModal title="Sort by" shape="round" onSortByChange={onSortByChange} sortValue={sortValue} sortItems={sortItems} />
  ) : null;
};

SortBy.propTypes = {
  onSortByChange: PropTypes.func.isRequired,
  classes: PropTypes.object,
  label: PropTypes.string,
  sortValue: PropTypes.any,
  sortItems: PropTypes.arrayOf(PropTypes.shape({ display: PropTypes.string, value: PropTypes.string })),
};

export { SortBy as default, SortBy };
